import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/scss/_reset.css'
import '@/assets/scss/common.scss'
import '@/assets/scss/style.css'
import { Message, Icon, Dialog, Loading } from 'element-ui'
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
Vue.use(Icon)
Vue.use(Dialog)
Vue.use(Loading)
Vue.config.productionTip = false
Vue.prototype.$message = Message
Vue.prototype.api = ''
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
